// extracted by mini-css-extract-plugin
module.exports = {"root":"DetailsListing_root__28l54","link":"DetailsListing_link__8EnOZ","image":"DetailsListing_image__3Lfd4","text":"DetailsListing_text__IZ1UY"};